import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Cover from './components/Cover';
import AboutMe from './components/AboutMe';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Education from './components/Education';
import Contact from './components/Contact';
import Footnote from './components/Footnote';
import Archive from './components/Archive'; // Import the Archive component
import Spotlight from './components/Spotlight';
import './styles.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Spotlight />
        <Header />
        <Routes>
          {/* Define routes */}
          <Route path="/" element={<><Cover /><AboutMe /><Education /><Experience /><Projects /><Contact /><Footnote /></>} />
          <Route path="/archive" element={<Archive />} /> {/* New route for Archive */}
        </Routes>
      </div>
    </Router>
  );
}


export default App;